import _ from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import { getLocalStorageAuth } from "@utils/localStorage";

export const PublicRoute = ({ children }) => {
  const auth = getLocalStorageAuth();
  const defaultLocation = useSelector(({ important }) => {
    return _.get(important, ["data", "defaultLocation"]);
  });
  if (_.isNil(auth)) {
    return children;
  } else {
    return <Navigate to={defaultLocation} />;
  }
};
